import { Box, Modal } from "@mui/material"
import { useEffect, useState } from "react"
import {
  btnsParent,
  desc,
  leftBtn,
  returnStyle,
  rightBtn,
  title,
} from "../../utils/popupModalStyle"
import Cookies from "js-cookie"
import { MyDispatch, MySelector } from "../../redux/store"
import { useDispatch } from "react-redux"
import { logoutGallery } from "../../redux/gallerySlice"
import { logoutEvent } from "../../redux/eventSlice"
import { setLogout } from "../../redux/utilSlice"
import { getDesignFontClass, getDesignCasingClass, getDesignModalSize } from "../../gallery-designs/registry"
import { safeSessionStorage } from "../../utils/safeStorage"

const LogoutModal = () => {
  const dispatch = useDispatch<MyDispatch>()
  const { eventId, data } = MySelector((state) => state.event)
  const { logout: logout_util } = MySelector((state) => state.util)
  const { theme } = MySelector((state) => state.theme)
  // Modals render in a portal, so apply the design font directly.
  const fontClass = getDesignFontClass(data?.galleryTheme)
  const casingClass = getDesignCasingClass(data?.galleryTheme)
  const modalSize = getDesignModalSize(data?.galleryTheme)

  const [showModal, setShowModal] = useState(false)

  const logout = () => {
    Cookies.remove(
      `${process.env.REACT_APP_IFE_WEB_GALLERY_COOKIE}?EVENT=${eventId}` || ""
    )
    safeSessionStorage.removeItem(process.env.REACT_APP_ACTIVE_SESSION || "")
    dispatch(logoutGallery())
    dispatch(logoutEvent())
    setShowModal(false)
    dispatch(setLogout(false))
    window.location.reload()
  }

  useEffect(() => {
    setShowModal(logout_util)
  }, [logout_util])

  return (
    <Modal
      aria-details="logout-modal"
      open={showModal}
      onClose={() => {
        setShowModal(false)
        dispatch(setLogout(false))
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={returnStyle(theme)}>
        <div className={`p-5 md:px-[26.11px] md:py-[33.25px] ${fontClass}`}>
          <p className={`${title} ${casingClass} ${modalSize.title}`}>Log Out</p>
          <p className={`${desc} ${casingClass} ${modalSize.desc}`} >Are you sure you want to Logout ?</p>
          <div className={btnsParent}>
            <button
              onClick={() => {
                setShowModal(false)
                dispatch(setLogout(false))
              }}
              className={`${leftBtn} ${casingClass} ${modalSize.button}`}
            >
              Cancel
            </button>
            <button onClick={logout} className={`${rightBtn} ${casingClass} ${modalSize.button}`}>
              Logout
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  )
}

export default LogoutModal
